<template>
  <div class="dynamic-content">
    <h1 class="page-title">Privacy & Data Protection</h1>
    
    <p class="desc-text">Your privacy matters to us.</p>
    <p class="desc-text">XigFor collects and processes personal data in accordance with our Privacy Policy.</p>
    <p class="desc-text section-spacing">We do not sell user data.</p>

    <div class="bottom-links">
      <div class="link-item">
        <router-link to="/privacy-policy" class="action-link">View Full Privacy Policy</router-link>
        <span class="arrow-icon">›</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyData'
}
</script>

<style scoped>
@import './shared-info-styles.css';
</style>
